import { Container, Typography } from "@mui/material";
import Chart from "../components/Chart";
import JWTTestComponent from "../components/JWTTestComponent";

export default function Dashboard() {
  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      <Typography variant="body1" gutterBottom>
        Welcome to the Analytics Dashboard! Here you can find insights and data
        visualizations to help you understand user engagement and performance
        metrics.
      </Typography>
      <Chart />
      <JWTTestComponent />
    </Container>
  );
}
